import { render, staticRenderFns } from "./CommissionOverviewReportCard.vue?vue&type=template&id=6c39bd9a"
import script from "./CommissionOverviewReportCard.vue?vue&type=script&lang=js"
export * from "./CommissionOverviewReportCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports